/* eslint-disable @next/next/no-img-element */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { useEvaluationActions } from "@_recoil/_actions";
import { evaluationAtom } from "@_recoil/_state";
import { htmlParse, remove_tags, swalError } from "@unisearch/helpers";

import { MdOutlineHome, MdOutlineSchool } from "react-icons/md";
import { BsBriefcase } from "react-icons/bs";
import styles from "./evaluation_objective.module.scss";

const EvaluationObjective = ({ formState, setFormState }) => {
  const { objectives, is_loading } = useRecoilValue(evaluationAtom);
  const [{ objectiveId }, setObjectiveId] = useRecoilState(evaluationAtom);

  const handleObject = (event) => {
    //get target value
    const { value, checked } = event.target;

    //when unchecked remove form selected
    if (!checked) {
      setObjectiveId((prev) => ({
        ...prev,
        objectiveId: undefined,
      }));
      return false;
    }

    if (checked) {
      setObjectiveId((prev) => ({
        ...prev,
        objectiveId: parseInt(value),
      }));
    }
  };

  useEffect(() => {
    setObjectiveId((prev) => ({
      ...prev,
      show_next: objectiveId ? true : false,
    }));
  }, [objectiveId]);

  return (
    <>
      <div className={styles.title_wrapper}>
        <div className={styles.title}>
          What is Your Primary Objective for Studying Overseas?
        </div>
      </div>
      <div className={styles.content}>
        <ul>
          {objectives.map((Obj, i) => {
            let Icon = Obj.icon;
            return (
              <label htmlFor={Obj?.objectiveId} key={`${Obj?.objectiveId}`}>
                <input
                  style={{ display: "none" }}
                  type="radio"
                  id={`${Obj?.objectiveId}`}
                  name="obj"
                  onChange={handleObject}
                  value={Obj?.objectiveId}
                  checked={
                    parseInt(Obj.objectiveId) == objectiveId ? true : false
                  }
                />
                <li>
                  {Obj.icon && (
                    <div className={styles.icon}>
                      <img
                        src={Obj.icon.src}
                        alt={Obj.icon.alt}
                        width={30}
                        height={30}
                      />
                    </div>
                  )}
                  <div className={styles.name}>
                    {remove_tags(Obj.objectiveDescription)}
                  </div>
                </li>
              </label>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default EvaluationObjective;
